// @flow
import React from 'react';
import { connect } from 'react-redux';
import notification from 'antd/lib/notification';
import { navigate } from '@reach/router';

import { canHandleService } from '../lib';
import type { ExpertiseServiceGpm, UserAccess } from '../../../lib/types';
import { expertiseServiceGpmApi } from '../../../lib/api';
import {
  convertVehicleToString,
  formatDateTimeToString
} from '../../../lib/helpers';
import { serviceTypes } from '../../../lib/enum';

import { Header } from '../../../components/layout';
import Breadcrumbs, { Crumb } from '../../../components/layout/Breadcrumbs';
import type { AppState } from '../../../ducks/redux';
import { Icon } from '../../../components/ui';
import { Panel, SectionContent } from '../elements';
import Section from '../../../components/layout/Section';
import Field from '../../../components/card/Field';
import Grid, { GridItem } from '../../../components/layout/Grid';

import { ActInfo } from './../../Act';

type Props = {
  id: number,
  userAccess: UserAccess[]
};

type State = {
  expertiseService: ExpertiseServiceGpm
};

class ExpertiseServiceGpmCard extends React.Component<Props, State> {
  state = {
    expertiseService: {}
  };

  async componentDidMount() {
    const { id } = this.props;
    try {
      const expertiseService = await expertiseServiceGpmApi.fetchExpertiseServiceGpm(
        parseInt(id, 10)
      );
      this.setState({ expertiseService });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  }

  render() {
    const { id, userAccess } = this.props;
    const { expertiseService } = this.state;

    const canHandle = canHandleService(userAccess);

    return (
      <>
        <Header
          left={
            <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to={'/services/expertises-services-gpm'}>
                Список экспертиз
              </Crumb>
              <Crumb>Экспертиза ПС/ТО приборов безопасности ПС №{id}</Crumb>
            </Breadcrumbs>
          }
          right={
            canHandle && (
              <Icon
                onClick={() =>
                  navigate(`/services/expertises-services-gpm/${id}/edit`)
                }
                size={16}
                style={{ cursor: 'pointer' }}
                type="edit"
              />
            )
          }
        />
        <Panel>
          <h1>Экспертиза ПС/ТО приборов безопасности ПС №{id}</h1>
        </Panel>
        <Section>
          <SectionContent>
            <Grid gutter="16px">
              {expertiseService.vehicle !== null ? (
                <GridItem>
                  <Field label="ТС">
                    {convertVehicleToString(expertiseService.vehicle)}
                  </Field>
                </GridItem>
              ) : null}

              {!!expertiseService.maintenanceDate && (
                <GridItem>
                  <Field label="Дата экспертизы">
                    {formatDateTimeToString(
                      expertiseService.maintenanceDate,
                      'DD.MM.YYYY'
                    )}
                  </Field>
                </GridItem>
              )}

              {!!expertiseService.nextActDate && (
                <GridItem>
                  <Field label="Следующая дата обслуживания">
                    {formatDateTimeToString(
                      expertiseService.nextActDate,
                      'DD.MM.YYYY'
                    )}
                  </Field>
                </GridItem>
              )}

              <GridItem>
                <Field label="Вид услуг">
                  {serviceTypes[expertiseService.services]}
                </Field>
              </GridItem>

              <GridItem>
                <Field label="Сумма оплаты, руб.">
                  {(expertiseService.paymentAmount || 0).toLocaleString(
                    'ru-RU',
                    {
                      style: 'currency',
                      currency: 'RUB'
                    }
                  )}
                </Field>
              </GridItem>
            </Grid>
          </SectionContent>
        </Section>

        {expertiseService && expertiseService.act && (
          <ActInfo act={expertiseService.act} />
        )}
      </>
    );
  }
}

export default connect((state: AppState, ownProps: { id: string }) => ({
  id: parseInt(ownProps.id, 10),
  userAccess: state.auth.profile.access
}))(ExpertiseServiceGpmCard);
